import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Modal, Box, Button } from '@mui/material';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import Cookies from 'js-cookie';

import '../../styles/navigation.css';

// Icon Imports --------------------------------------

import { FiHome, FiLogOut } from 'react-icons/fi';
import { BsBook, BsCodeSquare } from 'react-icons/bs';
import { BiComment } from 'react-icons/bi';
import { ImStack } from 'react-icons/im';
import { GrDocumentNotes } from 'react-icons/gr';
import { CgProfile } from 'react-icons/cg';

import { MdOutlineDashboardCustomize, MdWork } from 'react-icons/md';
import { IoPeopleOutline } from 'react-icons/io5';
import { FaPeopleArrows } from 'react-icons/fa';
import MilitaryTechRoundedIcon from '@mui/icons-material/MilitaryTechRounded';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

import ProjIcon from '../../assets/images/noun-video-tutorial-4691955.svg';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import Diversity2Icon from '@mui/icons-material/Diversity2';

type Props = {
	children: JSX.Element;
};

const NavigationDrawer = ({ children }: Props) => {
	const userState = useSelector((state: any) => state.user);
	const courseState = useSelector((state: any) => state.course);
	const location = useLocation();

	const { batchManagerPhoneNumber, courseName, course } = courseState;

	const { user, announcement } = userState;

	const navigate = useNavigate();
	const [componentArray, setComponentArray] = useState<number[]>([
		1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	]);

	const componentToggler = (num: number) => {
		const temp = [...componentArray];
		for (let i = 0; i < componentArray.length; i++)
			temp[i] = num === i ? 1 : 0;
		console.log(temp);
		setComponentArray([...temp]);
	};

	const logout = () => {
		localStorage.clear();
		Cookies.remove('acciojobs-token', {
			domain: `.acciojob.com`,
		});
		window.open('https://auth.acciojob.com', '_self');
		console.log('logout');
	};

	useEffect(() => {
		if (courseName != null && user != null && course.unit != null) {
			
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			//@ts-ignore
			window.Intercom('boot', {
				api_base: 'https://api-iam.intercom.io',
				app_id: 'g7q3r89c',
				user_email: user.email,
				email: user.email,
				user_id: user.id,
				user_name: user.firstName + ' ' + user.lastName,
				"courseName": courseName,
				"unit_name": course.unit.unitname,
				"unit_id": course.unit.id,
			});
		}
	}, [courseName, user]);

	useEffect(() => {
		const path = location.pathname;
		if (path === '/gym' || path === '/gym-aptitude') {
			componentToggler(3);
		} else if (path === '/modules' || path === '/aptitude') {
			componentToggler(1);
		} else if (path === '/live-doubts') {
			componentToggler(2);
		} else if (path === '/onevone') {
			componentToggler(4);
		} else if (path === '/contests') {
			componentToggler(13);
		} else if (path === '/notes') {
			componentToggler(5);
		} else if (path === '/open-editor') {
			componentToggler(6);
		} else if (path === '/mycalendar') {
			componentToggler(7);
		} else if (path === '/projects') {
			componentToggler(8);
		} else if (path === '/refer-and-earn') {
			componentToggler(9);
		} else if (path === '/softskills') {
			componentToggler(11);
		} else if (path === '/job-portal') {
			componentToggler(12);
		} else {
			componentToggler(0);
		}
	}, []);

	const [headerMsg, setHeaderMsg] = useState('');
	const [showHeaderNotice, setShowHeaderNotice] = useState(false);
	const [showCompleteProfilePromptModal, setShowCompleteProfilePromptModal] =
		useState(false);
	useEffect(() => {
		if (announcement !== null && announcement.userCourseMapping) {
			if (announcement.header.type === 'HEADER') {
				setShowHeaderNotice(true);
			} else setShowHeaderNotice(false);
			setHeaderMsg(announcement.header.text);
		}
	}, [announcement]);

	useEffect(() => {
		if (
			user !== null &&
			location.pathname != '/profile' &&
			(user.currentCity === null ||
				user.jobStatus === null ||
				user.resume === null ||
				user.resume === '')
		) {
			setShowCompleteProfilePromptModal(true);
		}
	}, [user, ...componentArray]);

	useEffect(() => {
		if (
			user !== null &&
			location.pathname != '/profile' &&
			Array.isArray(user.roles) &&
			user.roles.includes('maincourse-user') &&
			(user.currentCity === null ||
				user.jobStatus === null ||
				user.resume === null ||
				user.resume === '')
		) {
			setShowCompleteProfilePromptModal(true);
		}
	}, [user, ...componentArray]);

	return (
		<div
			className={'dashboard-panel'}
			id={'dashID'}
		>
			<Modal
				open={showCompleteProfilePromptModal}
				onClose={() =>
					// setShowCompleteProfilePromptModal(
					// 	!showCompleteProfilePromptModal
					// )
					console.log('Asd')
				}
				aria-labelledby="complete-profile"
				aria-describedby="complete-profile-description"
				style={{ overflow: 'scroll' }}
			>
				<div className={'modal interviewbookingmodal'}>
					<h3>Please complete your profile details to continue.</h3>
					<p style={{ margin: '10px' }}>
						Make sure you complete both Personal & Professional Info
						& Also<u> upload your resume</u>{' '}
					</p>
					<Button
						style={{
							background: '#a71010',
							padding: '10px',
							margin: '20px',
						}}
						onClick={() => {
							setShowCompleteProfilePromptModal(
								!showCompleteProfilePromptModal
							);
							componentToggler(10);
							navigate('/profile');
						}}
						variant="contained"
					>
						Go to Profile
					</Button>
					<br />
					<a
						style={{
							color: `rgb(240, 180, 22)`,
							backgroundColor: `rgba(253, 242, 214, 0.5)`,
						}}
						onClick={() =>
							setShowCompleteProfilePromptModal(
								!showCompleteProfilePromptModal
							)
						}
					>
						<u>I will fill it later</u>
					</a>
				</div>
			</Modal>
			{showHeaderNotice ? (
				<div className={'banner'}>
					<p>{headerMsg}</p>
				</div>
			) : null}
			<div className={'side-panel'}>
				<div className={'top'}>
					<div className={'brand'}>
						<img
							src={`${window.location.origin}/acciojob_logo.svg`}
							alt={'acciojob'}
						/>
						<div>
							<h3>AccioJob</h3>
						</div>
					</div>
					<ul className={'menu'}>
						<li
							className={`${
								componentArray[0] === 1 ? 'active' : ''
							}`}
							onClick={() => {
								navigate('/');
								componentToggler(0);
							}}
						>
							<FiHome />
							<div className={'menu-item-name'}>
								<p>Home</p>
							</div>
						</li>
						<li
							className={`${
								componentArray[1] === 1 ? 'active' : ''
							}`}
							onClick={() => {
								navigate('/modules');
								componentToggler(1);
							}}
						>
							<BsBook />
							<div>
								<p>Modules</p>
							</div>
						</li>
						<li
							className={`${
								componentArray[2] === 1 ? 'active' : ''
							}`}
							onClick={() => {
								navigate('/live-doubts');
								componentToggler(2);
							}}
						>
							<BiComment />
							<div>
								<p>Live Doubt</p>
							</div>
						</li>
						<li
							className={`${
								componentArray[3] === 1 ? 'active' : ''
							}`}
							onClick={() => {
								navigate('/gym');
								componentToggler(3);
							}}
						>
							<ImStack />
							<div>
								<p>Gym</p>
							</div>
						</li>
						<li
							className={`${
								componentArray[13] === 1 ? 'active' : ''
							}`}
							onClick={() => {
								navigate('/contests');
								componentToggler(13);
							}}
						>
							<MilitaryTechRoundedIcon />
							<div>
								<p>Contests</p>
							</div>
						</li>
						<li
							className={`${
								componentArray[4] === 1 ? 'active' : ''
							}`}
							onClick={() => {
								navigate('/onevone');
								componentToggler(4);
							}}
						>
							<FaPeopleArrows />
							<div>
								<p>Sessions</p>
							</div>
						</li>
						<li
							className={`${
								componentArray[5] === 1 ? 'active' : ''
							}`}
							onClick={() => {
								navigate('/notes');
								componentToggler(5);
							}}
						>
							<GrDocumentNotes />
							<div>
								<p>Notes</p>
							</div>
						</li>
						<li
							className={`${
								componentArray[6] === 1 ? 'active' : ''
							}`}
							onClick={() => {
								navigate('/open-editor');
								componentToggler(6);
							}}
						>
							<BsCodeSquare />
							<div>
								<p>Open Editor</p>
							</div>
						</li>
						<li
							className={`${
								componentArray[7] === 1 ? 'active' : ''
							}`}
							onClick={() => {
								navigate('/mycalendar');
								componentToggler(7);
							}}
						>
							<CalendarTodayIcon />
							<div>
								<p>Calendar</p>
							</div>
						</li>
						<li
							className={`${
								componentArray[11] === 1 ? 'active' : ''
							}`}
							onClick={() => {
								navigate('/softskills');
								componentToggler(11);
							}}
						>
							<Diversity2Icon />
							<div>
								<p>Soft Skills</p>
							</div>
						</li>
						<li
							className={`${
								componentArray[8] === 1 ? 'active' : ''
							}`}
							onClick={() => {
								navigate('/projects');
								componentToggler(8);
							}}
						>
							<img
								src={ProjIcon}
								style={{ height: '24px', width: '48px' }}
							/>
							<div>
								<p>Projects</p>
							</div>
						</li>
						<li
							className={`${
								componentArray[9] === 1 ? 'active' : ''
							}`}
							onClick={() => {
								navigate('/refer-and-earn');
								componentToggler(9);
							}}
						>
							<AttachMoneyIcon />
							<div>
								<p>{'Refer & Earn'}</p>
							</div>
						</li>
						{
							<li
								className={`${
									componentArray[12] === 1 ? 'active' : ''
								}`}
								onClick={() => {
									navigate('/job-portal');
									componentToggler(12);
								}}
							>
								<MdWork />
								<div>
									<p>Job Portal</p>
								</div>
							</li>
						}
					</ul>
				</div>

				<div className={'bottom'}>
					<ul className={'menu'}>
						{batchManagerPhoneNumber !== null &&
						batchManagerPhoneNumber !== '' ? (
							<li
								onClick={() => {
									window.open(
										`https://wa.me/+91${batchManagerPhoneNumber}`
									);
									// componentToggler(5;
								}}
							>
								<IoPeopleOutline />
								<div>
									<p>Contact Batch Manager</p>
								</div>
							</li>
						) : null}
						<li
							className={`${
								componentArray[10] === 1 ? 'active' : ''
							}`}
							onClick={() => {
								navigate('/profile');
								componentToggler(10);
							}}
						>
							<CgProfile />
							<div>
								<p>Profile</p>
							</div>
						</li>
					</ul>
					<div className={'user-info'}>
						<p className={'name-initial'}>
							{user !== null ? user.firstName[0] : null}
						</p>
						{/*{user !== null && user.imageUrl !== null ? (*/}
						{/*	<img src={user.imageUrl} />*/}
						{/*) : (*/}
						{/*	<img*/}
						{/*		src={`${window.location.origin}/defaults/Avatar.svg`}*/}
						{/*	/>*/}
						{/*)}*/}
						<div>
							<div className={'user-details'}>
								<h4>
									{user !== null ? user.firstName : null}{' '}
									{user !== null ? user.lastName : null}
								</h4>
								{/*<p>{user !== null ? user.email : null}</p>*/}
							</div>
							<div
								className={'logout-btn'}
								onClick={logout}
							>
								<FiLogOut />
							</div>
						</div>
					</div>
				</div>
			</div>
			<div
				className={'main-window'}
				style={{ paddingTop: `${showHeaderNotice ? '10px' : '0px'}` }}
			>
				{children}
			</div>
		</div>
	);
};

export default NavigationDrawer;
